import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@NgModule({
  declarations: [],
  exports: [BreadcrumbComponent],
  imports: [CommonModule, QueryParamModule, FontAwesomeModule, BreadcrumbComponent],
})
export class BreadcrumbModule {}
